import { axiosInstance } from 'apis';
import { getBaseURL } from 'utility/baseURL';

const baseURL = getBaseURL();

const EOrganization = {
	organization: baseURL + '/keepaSite/OrganizationRegistration',
};
const organizationAPIs = {
	setOrganization: (data, option = {}) => axiosInstance.post(EOrganization.organization, data, option),
};
export { organizationAPIs };
